<!--  Copied from Desp footer code  -->
    <!-- Footer Container -->
    <div id="footer-container">
      <div id="footer-inner-container">

          <!-- Left Container -->
          <div id="footer-left-container">
              <img id="footer-desp-logo" alt="desp-home" src="/logos/desp_logo.svg">
          </div>


        <!-- Central Container -->
        <div id="footer-central-container">
          <a href="https://destination-earth.eu" target="_blank">
            <img class="footer-logo" alt="destination earth" src="/logos/destination-earth.png">
          </a>
          <a href="https://european-union.europa.eu/" target="_blank">
            <img class="footer-logo" alt="eu commission" src="/logos/funded-by-EU.png">
          </a>
          <a>
            <img class="footer-logo" alt="implemented by" src="/logos/implemented-by.png">
          </a>
          <a href="https://www.ecmwf.int/" target="_blank">
            <img class="footer-logo" alt="ecmwf" src="/logos/ecmwf.png">
          </a>
          <a href="https://www.esa.int/" target="_blank">
            <img class="footer-logo" alt="esa" src="/logos/esa.png">
          </a>
          <a href="https://www.eumetsat.int/" target="_blank">
            <img class="footer-logo" alt="eumetsat" src="/logos/eumetsat.png">
          </a>
        </div>

        <!-- Right Container -->
        <div id="footer-right-container">
          <i data-feather="menu" id="footer-menu-icon"></i>
        </div>
      </div>

      <!-- Footer menu -->
      <div id="footer-menu">
       
        <a class="frame-link" href="https://platform.destine.eu/code-of-conduct/" target="_blank">Code of Conduct</a>
        <a class="frame-link" href="https://platform.destine.eu/terms-and-conditions/" target="_blank">Terms and Conditions</a>
        <a class="frame-link" href="https://platform.destine.eu/privacy-policies/" target="_blank">Privacy Policies</a>
        <a class="frame-link" href="https://platform.destine.eu/legal-notice/" target="_blank">Legal Notice</a>
      
       
        <div class="mobile-link">
          <hr>
          <a class="footer-frame-link" href="https://destination-earth.eu" target="_blank">
            <img class="mobile-footer-logo" alt="destination earth" src="/logos/destination-earth.png">
          </a>
          <a class="footer-frame-link" href="https://european-union.europa.eu/" target="_blank">
            <img class="mobile-footer-logo" alt="eu commission" src="/logos/funded-by-EU.png">
          </a>
          <a class="footer-frame-link">
            <img class="mobile-footer-logo" alt="implemented by" src="/logos/implemented-by.png">
          </a>
          <a class="footer-frame-link" href="https://www.ecmwf.int/" target="_blank">
            <img class="mobile-footer-logo" alt="ecmwf" src="/logos/ecmwf.png">
          </a>
          <a class="footer-frame-link" href="https://www.esa.int/" target="_blank">
            <img class="mobile-footer-logo" alt="esa" src="/logos/esa.png">
          </a>
          <a class="footer-frame-link" href="https://www.eumetsat.int/" target="_blank">
            <img class="mobile-footer-logo" alt="eumetsat" src="/logos/eumetsat.png">
          </a>
        </div>
      </div>
    </div>
  